import * as React from 'react';
import { BrowserRouter as Router, Route, Link, Switch, NavLink } from "react-router-dom";

import ErrorBoundary from '../errorboundary/ErrorBoundary';
import Project from '../project/Project';
import NoMatch from '../404/NoMatch';
import Notifications from '../notifications/Notifications';

import './App.css';

import '../../../node_modules/bootstrap/dist/css/bootstrap.css';
import '../../../node_modules/jquery/dist/jquery.js';
import '../../../node_modules/bootstrap/dist/js/bootstrap.js';
import { Logger, Record } from '../../stores/logger/Logger';
import Frontpage from '../frontpage/Frontpage';
import { Subscriber } from '../../services/util/PubSub';

class App extends React.Component<{}, { logger: Logger, alerts: Record[], baseUrl: string }> {
  constructor(props) {
    super(props);

    const logger = new Logger();
    logger.addSubscriber(new Subscriber("app", () => {
      this.setState({ alerts: this.state.logger.getAlerts() })
    }));

    this.state = {
      logger: logger,
      alerts: [],
      baseUrl: process.env.REACT_APP_BASEURL ? process.env.REACT_APP_BASEURL : ""
    }
  }

  public render() {
    return (

      <Router basename={this.state.baseUrl}>
        <React.Fragment>
          <nav className="navbar navbar-expand-md navbar-light" id="navigation">
            <Link className="navbar-brand" to="/">
              <img src="/docs/4.1/assets/brand/bootstrap-solid.svg" width="30" height="30" className="d-inline-block align-top" alt="" />
              >> Project Calculator
              </Link>

            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/" activeClassName="active">Home <span className="sr-only">(current)</span></NavLink>
                </li>
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Examples
        </a>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <NavLink className="dropdown-item" to="/project/sample">Sample project</NavLink>
                    <NavLink className="dropdown-item" to="/project/lansimetro_four_cars">Lansimetro (four cars)</NavLink>
                    <NavLink className="dropdown-item" to="/project/lansimetro_five_cars">Lansimetro (five cars)</NavLink>
                  </div>
                </li>
              </ul>
            </div>
          </nav>

          <div className="container-fluid">
            <ErrorBoundary>
              <div className="row">
                <div className="col-md">
                  <Switch>
                    <Route render={props => <Notifications {...props} logger={this.state.logger} />} />
                  </Switch>
                </div>
              </div>

              <Switch>
                <Route exact path="/" render={props => <Frontpage {...props} baseUrl={this.state.baseUrl} />} />
                <Route path="/project/:id" render={props => <Project {...props} logger={this.state.logger} baseUrl={this.state.baseUrl} />} />
                <Route path="/404" component={NoMatch} />
                <Route component={NoMatch} />
              </Switch>
            </ErrorBoundary>

          </div>
        </React.Fragment>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app/App.tsx